import React, { useEffect, useRef } from 'react';
import { Card, CardContent, CardDescription, CardTitle } from '@core-ui/Components/ui/card.tsx';
import { useTranslation } from 'react-i18next';
import { Button } from '@core-ui/Components/ui/button';
import { Mic } from 'lucide-react';
import { SocialOrbit } from '@core-ui/Components/ui/social-orbit.tsx';
import useMicrophone from '../../../hooks/useMicrophone';

const MicrophoneSetupModal: React.FC = () => {
  const { t } = useTranslation();
  const hasRenderedRef = useRef(false);
  const { setupMicrophonePermissions, isMicrophoneAllowed, validateMicrophoneStatus } = useMicrophone();

  async function clickButton (): Promise<void> {
    await setupMicrophonePermissions();
  }
  
  useEffect(() => {
    if (hasRenderedRef.current) {
      return;
    }

    hasRenderedRef.current = true;
    void validateMicrophoneStatus();
  }, []);
    
  return (
    <>
      {!(isMicrophoneAllowed) && (
        <Card className="flex justify-center items-center absolute z-[5] w-full h-full backdrop-blur-sm bg-card/70 border-card/70">
          <CardContent className="relative flex flex-col justify-center items-center -translate-y-20 space-y-4">
            <SocialOrbit
              rippleCount={3}
              rippleDuration={2}
              orbitDuration={30}
            >
              <div className="flex items-center justify-center w-16 h-16 rounded-full">
                <Mic size={100} className="stroke-1"/>
              </div>
            </SocialOrbit>
            <CardTitle data-qa-id="microphone-setup-title" className="-mt-20 text-2xl font-bold text-foreground">
              {t('microphoneSetup.title', 'Microphone Setup')}
            </CardTitle>
            <CardDescription>
              {t('microphoneSetup.description', 'Enable browser access to your microphone to proceed.')}
            </CardDescription>
            <Button 
              data-qa-id="microphone-setup-button"
              onClick={() => {
                void clickButton(); 
              }}
              className=""
            >
              {t('microphoneSetup.checkMicrophoneAccess', 'Check Microphone Access')}  
            </Button>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default MicrophoneSetupModal;
